import { render, staticRenderFns } from "./EditTextArea.vue?vue&type=template&id=745f6930&scoped=true"
import script from "./EditTextArea.vue?vue&type=script&lang=ts"
export * from "./EditTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f6930",
  null
  
)

export default component.exports